<app-payroll-management-tabs></app-payroll-management-tabs>

<div class="card">
  <div class="card-body">
    <h2>Manage Reimbursement Types</h2>
    <p class="text-muted">Configure the choices employees can submit and the payroll code used for future requests.</p>

    <i *ngIf="loading" class="material-icons rotate text-muted">loop</i>
    <div *ngIf="!loading" class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Payroll Export Code</th>
            <th>Allow AA Initial Approval</th>
            <th>Active</th>
            <th>Display Order</th>
            <th *ngIf="canEdit"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="canEdit">
            <td><input id="newReimbursementTypeName" class="form-control" maxlength="100" [(ngModel)]="newType.name"></td>
            <td><input id="newReimbursementTypeCode" class="form-control" maxlength="50" [(ngModel)]="newType.payrollExportCode"></td>
            <td class="text-center"><input type="checkbox" [(ngModel)]="newType.allowAAInitialApproval"></td>
            <td class="text-center"><input type="checkbox" [(ngModel)]="newType.isActive"></td>
            <td><input type="number" min="0" class="form-control" [(ngModel)]="newType.displayOrder"></td>
            <td><button id="addReimbursementType" type="button" class="btn btn-primary"
                        [disabled]="savingID != null || !valid(newType)" (click)="add()">Add</button></td>
          </tr>
          <tr *ngFor="let type of types" [attr.data-reimbursement-type-id]="type.id">
            <td><input class="form-control" maxlength="100" [(ngModel)]="type.name" [disabled]="!canEdit"></td>
            <td><input class="form-control" maxlength="50" [(ngModel)]="type.payrollExportCode" [disabled]="!canEdit"></td>
            <td class="text-center"><input type="checkbox" [(ngModel)]="type.allowAAInitialApproval" [disabled]="!canEdit"></td>
            <td class="text-center"><input type="checkbox" [(ngModel)]="type.isActive" [disabled]="!canEdit"></td>
            <td><input type="number" min="0" class="form-control" [(ngModel)]="type.displayOrder" [disabled]="!canEdit"></td>
            <td *ngIf="canEdit"><button type="button" class="btn btn-primary"
                                       [disabled]="savingID != null || !valid(type)" (click)="save(type)">Save</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
